<template>
    <SlottedModal
        border-radius="xl"
        modal-type="transparent"
        show-button="hide"
        alignment="tight">
        <template #trigger>
            <button>
                <span class="font-normal text-navy-dark underline">{{ pricingDetails.label || 'Pricing Details'}}</span>
            </button>
        </template>
        <template #contents>
            <div class="grid gap-4 text-base font-book leading-5"
                :class="gridColumnsClass">
                <div
                    v-for="(card, index) in pricingDetails.cards"
                    :key="index"
                    class="flex flex-col gap-4 bg-blue-lightest p-6 rounded-xl text-navy-dark">
                    <div class="text-center tracking-normal">
                        <div class="uppercase font-normal text-blue-light text-lg">{{ card.section.replace('#', promoMonths).replace('*', secondaryPromoMonths) }}</div>
                            <h4 class="mt-4 text-xl leading-tight">{{ card.title }}</h4>
                        </div>
                        <div class="flex flex-col gap-4 items-stretch h-full mt-8">
                            <div v-for="(item, key) in card.pricing"
                                 :key="key"
                                 class="flex justify-between" :class="key === 0? 'font-normal text-lg': 'font-thin text-base'">
                                <div>{{ item.name }}</div>
                                <div>{{ priceFilter(item.price) }}</div>
                            </div>
                            <div class="col-span-full border-t-2 border-blue-polar mb-4 mt-auto"></div>
                            <div class="flex justify-between items-center">
                                <span class="font-bold text-lg">Estimated Monthly Total</span>
                                <span class="justify-self-end font-bold text-xl">{{ estimatedMonthlyTotal(card.pricing) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
        </template>
        <template #footer>
            <div class="text-center desktop:max-w-3/4 m-auto">
                {{ pricingDetails.disclaimer }} Includes $10 Autopay & EcoSave discount. Displayed offers are based on your estimated ZIP Code. Services, pricing and availability are subject to change based on your specific service location.<br>
                <div class="mt-2">
                    <span
                        v-if="promoLink"
                        class="block desktop:inline mt-4 desktop:mt-0">
                        <a
                            :href="promoLink"
                            class="text-navy underline">
                            {{ promoLabel }}
                        </a>
                        -
                    </span>
                    <a href="/policies-agreements"
                    class="text-navy underline">
                        Terms and Conditions
                    </a>
                </div>
            </div>
        </template>
    </SlottedModal>
</template>

<script>
    import { mapState } from "vuex"
    import SlottedModal from '@/organisms/SlottedModal'

export default {
    name: 'InfoModal',
    components: {
        SlottedModal,
    },
    props: {
        fullPrice: {
            type: Number,
            default: 0,
        },
        promoPrice: {
            type: Number,
            default: 99,
        },
        promoMonths: {
            type: String,
            default: "12",
        },
        pricingDetails: {
            type: Object,
            default: null,
        },
        secondaryPromoMonths: {
            type: String,
            default: "12",
        },
        promoLink: {
            type: String,
            default: null,
        },
        promoLabel: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState([
            'meta',
        ]),
        gridColumnsClass() {
            return {
                1: 'grid-cols-1',
                2: 'desktop:grid-cols-2',
                3: 'desktop:grid-cols-3',
                4: 'desktop:grid-cols-4',
            }[this.pricingDetails?.cards?.length] ?? 'desktop:grid-cols-2'
        },
    },
    methods: {
        priceFilter(price) {
            // Special case for WiFi Your Way Home in Ohio
            if (this.meta.stateOrProvince === 'OH' && 
                price === '$17.99' && 
                this.pricingDetails?.cards?.some(card => 
                    card.section.includes('After')
                )) {
                return '$14.99'
            }
            return {
                '#SP': this.toCurrency(this.fullPrice, true),
                '#PD': '-' + this.toCurrency(this.fullPrice - this.promoPrice - 10), // the 10 is the autopay discount
            }[price] ?? price
        },
        estimatedMonthlyTotal(pricing) {
            return this.toCurrency(pricing.reduce((total, item) => {
                return total + parseFloat(this.priceFilter(item.price).replace('$', ''))
            }, 0), true)
        },
    },
}
</script>
